import * as moment from "moment";
import { Moment } from "moment";
import { TimeSpanString } from "client/resources";

export default class DateFormatter {

    public static dateToShortFormat(dateTime: string | undefined): string | null {
        if (!dateTime) {
            return null;
        }
        const dateMoment = moment(dateTime);
        return dateMoment.format("LLL");
    }

    public static dateToLongFormat(dateTime: string | undefined): string | null {
        if (!dateTime) {
            return null;
        }
        const dateMoment = moment(dateTime);
        return dateMoment.format("LLLL");
    }

    public static dateToCustomFormat(dateTime: string | Moment, format: string): string | null {
        if (!dateTime) {
            return null;
        }
        const dateMoment = moment(dateTime);
        return dateMoment.format(format);
    }

    public static moment(input: string, format: string): string {
        const when = new Date(Date.parse(input));
        const m = moment(when);
        format = format || "LLLL";
        const display = format === "ago" ? m.fromNow() : m.format(format);
        return display;
    }

    public static momentAgo(input: string): string {
        const when = new Date(Date.parse(input));
        return moment(when).fromNow();
    }

    public static momentFrom(fromDate: string, toDate: string): string | null {
        if (!fromDate) {
            return null;
        }

        const fromMoment = moment(fromDate);
        const toMoment = toDate ? moment(toDate) : moment();

        const diff = fromMoment.diff(toMoment);
        const duration = moment.duration(diff);
        const mins = duration.minutes();
        const hours = duration.hours();
        const days = Math.floor(duration.asDays());
        let result = (mins === 1 ? "1 minute" : mins + " minutes");
        result = (hours !== 0 ? (hours === 1 ? "1 hour" : hours + " hours") + " and " : "") + result;
        result = (days !== 0 ? (days === 1 ? "1 day" : days + " days") + ", " : "") + result;
        return result;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/utils/DateFormatter/DateFormatter.tsx